import React from "react";
import { Box } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import Logo from "../../assets/icon/Logo 1-4.svg";
import LogoDark from "../../assets/icon/Logo 1-4 dark.svg";

// The 121 Islam logo. In Dark its small near-black mark is white, so it shows on the dark
// sidebar and sign-in page (047 D112); the blue is the same in both modes.
const BrandLogo = (props) => {
  const { mode } = useColorScheme();
  return <Box component="img" src={mode === "dark" ? LogoDark : Logo} {...props} />;
};

export default BrandLogo;
